import React, { useEffect, useState } from 'react';
import api from '../api';

function extractYoutubeId(url) {
  const match = (url || '').match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  );
  return match ? match[1] : null;
}

function formatDate(iso) {
  if (!iso) return '';
  return iso.slice(0, 10);
}

export default function YoutubeMaterial() {
  const [rows, setRows] = useState([]);
  const [title, setTitle] = useState('');
  const [url, setUrl] = useState('');
  const [saving, setSaving] = useState(false);
  const [urlError, setUrlError] = useState('');
  const [playingId, setPlayingId] = useState(null);

  const load = () => {
    api.get('/materials/youtube').then((res) => setRows(res.data));
  };

  useEffect(() => {
    load();
  }, []);

  const handleAdd = async () => {
    const t = title.trim();
    const u = url.trim();
    if (!t || !u) return;
    if (!extractYoutubeId(u)) {
      setUrlError('올바른 유튜브 주소가 아닙니다.');
      return;
    }
    setUrlError('');
    setSaving(true);
    try {
      await api.post('/materials/youtube', { title: t, url: u });
      setTitle('');
      setUrl('');
      load();
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    await api.delete(`/materials/youtube/${id}`);
    if (playingId === id) setPlayingId(null);
    load();
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>유튜브 자료</h2>
      </div>

      <div className="card">
        <div className="form-row youtube-material-add-row">
          <div className="youtube-material-add-fields">
            <input
              type="text"
              className="field-input"
              placeholder="제목"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <input
              type="text"
              className="field-input"
              placeholder="유튜브 주소 (예: https://www.youtube.com/watch?v=...)"
              value={url}
              onChange={(e) => { setUrl(e.target.value); setUrlError(''); }}
              onKeyDown={(e) => { if (e.key === 'Enter') handleAdd(); }}
            />
          </div>
          <button className="btn-primary btn-inline youtube-material-add-btn" type="button" onClick={handleAdd} disabled={saving}>
            등록
          </button>
        </div>
        {urlError && <div className="field-error">{urlError}</div>}
      </div>

      <div className="card">
        {rows.length === 0 && <div className="empty-row">등록된 유튜브 자료가 없습니다.</div>}
        {rows.map((r) => {
          const videoId = extractYoutubeId(r.url);
          const isPlaying = playingId === r.id;
          return (
            <div key={r.id} className="youtube-material-row">
              <div className="youtube-material-item" onClick={() => setPlayingId(isPlaying ? null : r.id)}>
                {videoId ? (
                  <img
                    className="youtube-material-thumb"
                    src={`https://img.youtube.com/vi/${videoId}/mqdefault.jpg`}
                    alt=""
                  />
                ) : (
                  <div className="youtube-material-thumb youtube-material-thumb-empty">?</div>
                )}
                <div className="youtube-material-info">
                  <div className="youtube-material-title">{r.title}</div>
                  <div className="youtube-material-url">{r.url}</div>
                  <div className="youtube-material-meta">{formatDate(r.createat)}</div>
                </div>
                <button
                  className="btn-link"
                  type="button"
                  onClick={(e) => { e.stopPropagation(); handleDelete(r.id); }}
                >
                  삭제
                </button>
              </div>
              {isPlaying && (
                <div className="youtube-material-player">
                  {videoId ? (
                    <iframe
                      src={`https://www.youtube.com/embed/${videoId}`}
                      title={r.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  ) : (
                    <div className="empty-row">재생할 수 없는 주소입니다.</div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
